import Separator from '@commons/components/Separator';
import type { DrupalBlock } from '@commons/types/drupal';
import type { ColorOrInline, Spacing } from '@commons/types/styles';

// Type definition for the SeparatorBlock component properties.

type Props = DrupalBlock<{
  dash: boolean;
  color: 'default' | ColorOrInline;
  marginTop: Spacing;
  marginBottom: Spacing;
}>;

/**
 * Separator block component.
 */

const SeparatorBlock = ({ content }: Props) => {
  const { dash = false, color = 'default', ...props } = content;
  const parsedColor = color === 'default' ? undefined : color;

  return <Separator dash={dash} color={parsedColor} className="w-100" {...props} />;
};

export default SeparatorBlock;
